import { Component, OnInit, ViewChild } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
declare var document, $;

@Component({
  selector: 'app-available-orders',
  templateUrl: './available-orders.component.html',
  styleUrls: ['./available-orders.component.css']
})
export class AvailableOrdersComponent implements OnInit {

  public despositionArray   : any = AppSettings.disposition;
  public documentTypeArray  : any = AppSettings.documentType;
  public siteAbbr           : any = AppSettings.siteAbbr;
  public orderStatus        : any = AppSettings.orderStatus;
  public writersAction      : any = ['Assign to me'];
  public loading            : any = false;
  public paginatePage       : any;
  public leads              : any = [];
  public lead_Index         : any = null;
  public comments           : any = [];
  public agentComments      : any = [];
  public qaComments         : any = [];
  public agentsSub          : any;
  public agents             : any;
  public writers            : any;
  public qa                 : any;
  public loader             : any;
  public activeUser         : any;
  public floatingAlert      : any = true;


  @ViewChild(DataTableDirective)
  public dtElement    : DataTableDirective;
  public dtOptions    : DataTables.Settings = {};
  public dtTrigger    : any = new Subject();

  public searchParams          : any = { order_id: '', date_from: '', date_to: '' };
  public fullRangeDate         : any;
  public selectedDesposition   : any;

  constructor(
    private helperService     : HelperService,
    private agentsService     : Agents,
    private authenticationService : AuthenticationService,
  ) {

    // Get Agents
    this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
      if (agents) {
        this.agents  = agents.agents;
        this.qa      = agents.qa;
        this.writers = agents.writers;
      }
    });

    this.activeUser = this.authenticationService.get_currentUserValue();

    // Set Order By
    let orderBy = [ 11, "asc" ];
    if(this.activeUser.is_writer)
      orderBy = [ 10, "asc" ];

    this.dtOptions = {
      paging: true,
      info: true,
      // ordering: false,
      pagingType: 'full_numbers',
      pageLength: 25,
      serverSide: true,
      processing: true,
      searching: false,
      'language': AppSettings.dataTableLang,
      "columnDefs": [
        { "orderable": false,                       visible: this.activeUser.Portal_Writer,               "targets": 0 },
        { "orderable": false,                       visible: this.activeUser.Portal_Writer,               "targets": 1 },
        { "orderable": false,                       visible: this.activeUser.Portal_Writer,               "targets": 2 },
        { "orderable": false,                       visible: this.activeUser.Portal_Writer,               "targets": 3 },
        { "orderable": false,                       visible: this.activeUser.Portal_Writer,               "targets": 4 },
        { "orderable": false,                       visible: this.activeUser.Portal_Writer,               "targets": 5 },
        { "orderable": false,                       visible: this.activeUser.Portal_Writer,               "targets": 6 },
        { "orderable": false,                       visible: this.activeUser.Portal_Writer,               "targets": 7 },
        { "orderable": false,                       visible: this.activeUser.Portal_Writer,               "targets": 8 },
        { "orderable": false,                       visible: this.activeUser.is_writer,                   "targets": 9 },
        { "orderable": this.activeUser.is_writer,   visible: this.activeUser.Portal_Writer,               "targets": 10 },
        { "orderable": true,                        visible: this.activeUser.is_writermanager,            "targets": 11 },
        { "orderable": false,                       visible: this.activeUser.is_writermanager,            "targets": 12 },
        { "orderable": false,                       visible: this.activeUser.is_writer,                   "targets": 13 },
    ],
      "order": [orderBy],
      ajax: (dataTablesParameters: any, callback) => {
        // Show Loader
        this.loading = true;
        // console.log("dataTablesParameters", dataTablesParameters);

        let url = AppSettings.API_ENDPOINT + 'writers/get-available-orders';

        let dtParams = {
                        order_id          : this.searchParams.order_id,
                        date_from         : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
                        date_to           : this.searchParams.date_to   ? this.helperService.caonvertDateToString(this.searchParams.date_to, false)   : '',
                        start             : dataTablesParameters.start,
                        length            : dataTablesParameters.length,
                        order             : dataTablesParameters.order,
                        columns           : dataTablesParameters.columns
                      };

        // For Record Serial Numbers
        this.paginatePage = dataTablesParameters.start;

        // Empty Data
        this.leads = [];

        this.helperService.httpPostRequestsDecryp(url, dtParams)
          .then( resp => {
              this.leads        = JSON.parse(resp);

              // Set Default page len
              this.dtOptions.pageLength = this.dtElement['dt'].page.len();

              // Hide Loader
              this.loading = false;

              callback({
                recordsTotal: this.leads.total,
                recordsFiltered: this.leads.total,
                // recordsFiltered: resp['recordsFiltered'],
                // recordsFiltered: 1000,
                data: []
              });

              // // $(".paginate_button .current").css("color", "white");
              // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
              $('div.dataTables_length select').addClass('dt-form-control');
              $('div.dataTables_filter input').addClass('dt-form-control');
          })
          .catch(error => {
              // Set loader false
              this.loading = false;

              // // Rerender DT in case of failure
              // this.rerender();

              console.log("error: ",error);
          });
      },
      columns: [
        { data: 'id' },
        { data: 'order_id' },
        { data: 'name' },
        { data: 'acdLevel' },
        { data: 'document_type' },
        { data: 'subject' },
        { data: 'pages' },
        { data: 'citation' },
        { data: 'sources' },
        { data: 'compensation' },
        { data: 'writer_delivery_date' },
        { data: 'writer_delivery_date' },
        { data: 'agent_id' },
        { data: 'action' },
      ],
      // Use this attribute to enable the responsive extension
      responsive: false
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit(){
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();

    if (typeof this.agentsSub != 'undefined') {
      //prevent memory leak when component destroyed
      this.agentsSub.unsubscribe();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      // Destroy the table first
      dtInstance.destroy();

      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  splitFromTo(){
    if(this.fullRangeDate){
      this.searchParams.date_from = this.fullRangeDate[0];
      this.searchParams.date_to =   this.fullRangeDate[1];
    }

    this.rerender();
  }

  openAssignToMe_Writer_Modal(index) {
    this.lead_Index = index;

    let self = this;
    setTimeout(() => {
      self.leads.data[self.lead_Index].action = null;
    }, 50);

    // Open Modal
    ($('#writer_assignme_modal' + index) as any).modal('show');
    $(".modal-backdrop").click(function() {
      $("#writer_assignme_modal" + index).modal("hide");
    });
  }

  assignToMe_Writer() {
    // Hide Modal
    ($('#writer_assignme_modal' + this.lead_Index) as any).modal('hide');

    // Show Status Loader
    this.leads.data[this.lead_Index].loading = true;

    let url = AppSettings.API_ENDPOINT + "writers/assign-order";
    let data = { id: this.leads.data[this.lead_Index].id };

    this.helperService.httpPostRequests(url,data).then(resp => {
        // Hide Status Loader
        this.leads.data[this.lead_Index].loading = false;

        if(typeof resp != "undefined" && resp.status == "OK") {
          Swal.fire('', resp.message, 'success');

          // Remove lead as its assigned
          this.leads.data.splice(this.lead_Index, 1);
        } else {
          Swal.fire('', resp.message, 'error');
        }
    }).catch(err => {
        // Hide Status Loader
        this.leads.data[this.lead_Index].loading = false;

        Swal.fire('', 'Something went wrong. Please try again.', 'error');
    });
  }


  openAssignTo_Writer_byManager_Modal(index) {
    this.lead_Index = index;

    // Open Modal
    ($('#writer_assign_by_manager_modal' + index) as any).modal('show');
    $(".modal-backdrop").click(function() {
      $("#writer_assign_by_manager_modal" + index).modal("hide");
    });
  }

  revertAssignByManager(index) {
    this.leads.data[this.lead_Index].agent_id = null;

    // Hide Modal
    ($('#writer_assign_by_manager_modal' + index) as any).modal('hide');
  }

  assignTo_Writer_byManager(index) {
    // Hide Modal
    ($('#writer_assign_by_manager_modal' + index) as any).modal('hide');

    // Show Status Loader
    this.leads.data[this.lead_Index].loading = true;

    let url = AppSettings.API_ENDPOINT + "writers/assign-to-writer-by-manager";
    let data = { oid: this.leads.data[this.lead_Index].id, wid: this.leads.data[this.lead_Index].agent_id };

    this.helperService.httpPostRequests(url,data).then(resp => {
        // Hide Status Loader
        this.leads.data[this.lead_Index].loading = false;

        if(typeof resp != "undefined" && resp.status == "OK") {
          Swal.fire('', resp.message, 'success');

          // Remove lead as its assigned
          this.leads.data.splice(this.lead_Index, 1);
        } else {
          Swal.fire('', resp.message, 'error');
        }
    }).catch(err => {
        // Hide Status Loader
        this.leads.data[this.lead_Index].loading = false;

        Swal.fire('', 'Something went wrong. Please try again.', 'error');
    });
  }

  agentSearch(id, agentArr) {
    for (var i = 0; i < agentArr.length; i++) {
      if (agentArr[i].id === id) {
        return agentArr[i].name;
      }
    }
  }

  clearFilters(){
    this.fullRangeDate = '';
    this.searchParams = { order_id: '', date_from: '', date_to: '' };

    this.rerender();
  }

  showStatusColor(id, statusArr) {
    for (var i = 0; i < statusArr.length; i++) {
      if (statusArr[i].value === id) {
        return statusArr[i].color;
      }
    }
  }
  closeFloatingAlert(){
      this.floatingAlert = false;
  }

}
